(function() {
    function qs(scope, sel) { return (scope || document).querySelector(sel); }
    function qsa(scope, sel) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

    // Keep UI dismissal + section refresh in sync.
    var UPSELL_DISMISS_MS = 1600;

    function hideUpsellCard(root) {
      try {
        if (!root || !root.closest) return;
        var card = root.closest('.cd-card.cd-upsell');
        if (!card) return;
        // Hide immediately so the wrapper/title disappear in sync with the offer.
        card.style.display = 'none';
      } catch (_) {}
    }
  
    function pushGtmUpsell(eventName, meta) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          ecommerce: {
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || (window.__shopCurrency) || undefined,
            value: meta && meta.price != null ? (meta.price/100) : undefined,
            items: meta ? [{
              item_name: meta.productTitle,
              item_id: meta.productId,
              item_variant: meta.variantId,
              price: meta.price != null ? (meta.price/100) : undefined,
              quantity: 1,
              discount_flag: !!meta.discount
            }] : []
          },
          upsell_context: 'cart_below_items'
        });
      } catch (e) { /* no-op */ }
    }
  
    // Success overlay UI has been removed for the new cart drawer design.
  
    function addVariantToCart(variantId, onDone) {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      try {
        // Ensure all needed sections are returned for Shapes theme morphs
        formData.append('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
        formData.append('sections_url', window.location.pathname);
      } catch(_) {}
  
      var config;
      if (typeof fetchConfigDefaults === 'function') {
        config = fetchConfigDefaults('application/javascript');
      } else if (typeof fetchConfig === 'function') {
        config = fetchConfig('javascript');
      } else {
        config = { method: 'POST', headers: {} };
      }
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
  
      var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ||
                   (window.routes && window.routes.cart_add_url) ||
                   '/cart/add';
  
      fetch(addUrl, config)
        .then(function(r){ return r.json(); })
        .then(function(resp){ if (onDone) onDone(null, resp); return resp; })
        .then(function(resp){
          // Notify Shapes theme to morph cart sections
          try {
            document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {
              bubbles: true,
              detail: { response: resp }
            }));
          } catch(_) {}
        })
        .catch(function(e){ if (onDone) onDone(e); });
    }
  
    function setState(root, inCart) {
      var addBtn = qs(root, '[data-upsell-add]');
      if (!addBtn) return;

      if (inCart) {
        root.classList.add('is-added');
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.classList.remove('loading');
        try { addBtn.style.pointerEvents = 'none'; } catch(_) {}
        // Dismiss after a short moment (matches prior behaviour of disappearing)
        setTimeout(function(){
          try { root.classList.add('is-dismissing'); } catch(_) {}
          hideUpsellCard(root);
          // Refresh sections (async) so Liquid conditions fully take effect.
          try { document.dispatchEvent(new CustomEvent('theme:update:cart')); } catch (_) {}
        }, UPSELL_DISMISS_MS);
      } else {
        root.classList.remove('is-added');
        root.classList.remove('is-dismissing');
        addBtn.removeAttribute('aria-disabled');
        addBtn.classList.remove('loading');
        try { addBtn.style.pointerEvents = ''; } catch(_) {}
      }
    }
  
    function isVariantInCart(cartData, variantId) {
      try {
        var items = (cartData && cartData.items) || [];
        for (var i = 0; i < items.length; i++) { if (String(items[i].variant_id) === String(variantId)) return true; }
      } catch(_) {}
      return false;
    }
  
    function bind(root) {
      if (!root) return;
      var addBtn = qs(root, '[data-upsell-add]');
      // Legacy success blocks are intentionally ignored/hidden in CSS for the new design.
      try {
        var V = (window.GWP && window.GWP.VARIANTS) || {};
        var pre = (window.GWP && typeof window.GWP.isPreaccess === 'function') ? window.GWP.isPreaccess() : false;
        var admin = (window.GWP && typeof window.GWP.getCookie === 'function') ? window.GWP.getCookie('gwpAdmin') === 'true' : false;
        var isPreBlock = root.getAttribute('data-upsell-preaccess') === 'true';
        var targetVariant = root.getAttribute('data-variant-id');
        if (isPreBlock) {
          var showPre = (pre || admin) && !!window.GWP_FREE_EXHAUSTED;
          root.style.display = showPre ? '' : 'none';
          if (showPre && V.halfVariantId) targetVariant = String(V.halfVariantId);
        } else {
          var hideMain = (pre || admin) && !!window.GWP_FREE_EXHAUSTED;
          root.style.display = hideMain ? 'none' : '';
          if (!hideMain && V.retailVariantId) targetVariant = String(V.retailVariantId);
        }
        if (targetVariant) root.setAttribute('data-variant-id', targetVariant);
      } catch(_) {}
      if (!addBtn) return;

      addBtn.addEventListener('click', function() {
        if (addBtn.getAttribute('aria-disabled') === 'true') return;
        var variantId = root.getAttribute('data-variant-id');
        var productId = root.getAttribute('data-product-id');
        try { root.classList.remove('is-dismissing'); } catch(_) {}
        try { root.classList.remove('is-added'); } catch(_) {}
        try { root.classList.add('is-loading'); } catch(_) {}
        addBtn.setAttribute('aria-disabled', 'true');
        // Do not add a loading spinner for the new design (it causes an unwanted spin animation).

        var meta = {
          variantId: variantId,
          productId: productId,
          productTitle: qs(root, '.upsell-offer__title') ? qs(root, '.upsell-offer__title').textContent : undefined,
          price: undefined,
          discount: undefined
        };
        try {
          var priceEl = qs(root, '.upsell-offer__price--final');
          if (priceEl && priceEl.dataset && priceEl.dataset.cents) meta.price = parseInt(priceEl.dataset.cents, 10);
        } catch(_) {}
        pushGtmUpsell('upsell_impression_add_click', meta);
  
        addVariantToCart(variantId, function(err, resp){
          try { root.classList.remove('is-loading'); } catch(_) {}

          if (err) {
            // allow retry
            addBtn.removeAttribute('aria-disabled');
            try { addBtn.style.pointerEvents = ''; } catch(_) {}
            return;
          }

          // Mark as added (CSS switches "+ Add" -> "Added"), then dismiss.
          try { root.classList.add('is-added'); } catch(_) {}
          setState(root, true);
          pushGtmUpsell('upsell_add_to_cart', meta);
        });
      });
  
      pushGtmUpsell('upsell_impression', {
        variantId: root.getAttribute('data-variant-id'),
        productId: root.getAttribute('data-product-id'),
        productTitle: qs(root, '.upsell-offer__title') ? qs(root, '.upsell-offer__title').textContent : undefined
      });
  
      try {
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(evt){
            var inCart = isVariantInCart(evt && evt.cartData, root.getAttribute('data-variant-id'));
            setState(root, inCart);
            if (!inCart) {
              try {
                root.classList.remove('is-dismissing');
                root.classList.remove('is-added');
              } catch(_) {}
            }
          });
        }
      } catch(_) {}
    }
  
    function init() {
      qsa(document, '[data-upsell-root]').forEach(bind);
      try {
        var mo = new MutationObserver(function(muts){
          muts.forEach(function(m){
            Array.prototype.forEach.call(m.addedNodes || [], function(n){
              if (!(n && n.querySelectorAll)) return;
              if (n.matches && n.matches('[data-upsell-root]')) bind(n);
              qsa(n, '[data-upsell-root]').forEach(bind);
            });
          });
        });
        mo.observe(document.body, { childList: true, subtree: true });
      } catch(_) {}
      try { window.addEventListener('gwp:exhaustion', function(){ qsa(document, '[data-upsell-root]').forEach(function(r){ bind(r); }); }); } catch(_) {}
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();